import { SelectOption } from './../../../../../shared/object/select-option.model';

import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { debounceTime, filter, distinctUntilChanged } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, MDBDatePickerComponent } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RecorridoService } from 'src/app/services/recorrido.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarRecorridoLiquidacionComponent } from '../../modal-seleccionar-recorrido-liquidacion/modal-seleccionar-recorrido-liquidacion.component';
import { EstadoRecorridoService } from 'src/app/services/estado-recorrido.service';

@Component({
  selector: 'app-search-recorrido-table',
  templateUrl: './search-recorrido-table.component.html',
  styleUrls: ['./search-recorrido-table.component.scss'],
  providers: [SecurityService]
})
export class SearchRecorridoTableComponent implements OnInit {

  // Output
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();
  @Output() onrecorridoIniciado: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClean: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFechaLiquidacion: EventEmitter<any> = new EventEmitter<any>();
  // Modales
  @ViewChild('seleccionarRecorrido', { static: true }) seleccionarRecorridoModal: ModalDirective;
  @ViewChild('dpFecha', { static: true }) dpFecha: MDBDatePickerComponent
  @ViewChild(ModalSeleccionarRecorridoLiquidacionComponent, { static: true }) modalSeleccionarRecorrido: ModalSeleccionarRecorridoLiquidacionComponent

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  loading: boolean = false
  listaRecorridos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  HighlightRow : Number;
  HiddeTable: boolean = true;
  // Utils
  private log: any
  recorridoEnviar: any = null;
  recorridoSeleccionado: any = null
  optionsEstado: Array<any> = [];
  seleccionador: number = 1;

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private recorridoService: RecorridoService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private estadoRecorrido: EstadoRecorridoService,
    private datesService: DatesService,
  ) {
    this.log = this.clog.log('SELECCIONAR RECORRIDO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.createForm();
    this.formChangesSubscriptions();
    this.loadEstadoRecorrido()

  }
  private loadEstadoRecorrido() {
    //Estado Recorrido
    this.estadoRecorrido.GetByEstadoRecorridoLisquidacion(({ respuesta }) => {
      const { registros } = respuesta
      this.optionsEstado = registros.map(estado => ({ value: estado.codigo, label: estado.nombre, ...estado }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('listaEstado'), this.optionsEstado)
    })
  }
  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()

    this.formHeader = this.fb.group({
      // chofer: [null, []],
      choferNombre: [null, []],
      codigoRecorrido: [null, []],
      fecha: [null, []],
      listaEstado: [[]],
      fecha_liquidacion : currentDate
    });
  }

  ClickedRow(index, recorrido){
    this.HighlightRow = index;
    this.seleccionar(recorrido);
  }

  show() {
    this.clearAllData()
    this.seleccionarRecorridoModal.show()
  }

  private clearAllData() {
    // Establecer seleccionador antes de resetear para evitar que se dispare el autocompletado
    this.seleccionador = 0;
    this.formValidatorsService.reset(this.formHeader)
    this.dpFecha.clearDate()
    this.listaRecorridos = null
    // Resetear seleccionador después del reset para que funcione la próxima vez que el usuario escriba
    this.seleccionador = 1;
  }

  buscar(pageNumber: number) {
    this.HiddeTable = false;

    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaRecorridos = []
    this.loading = true

    const { codigoRecorrido, chofer, fecha, listaEstado } = this.formHeader.value
    const inputParams = {
      codigo: codigoRecorrido ? codigoRecorrido : -1,
      chofer_rut: -1,
      fecha,
      camion_patente: '',
      sucursal_codigo: this.sucursalCodigo,
      rut_empresa: this.rutEmpresa,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
      listaEstado,
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.recorridoService.obtenerRecoridosALiquidar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaRecorridos = registros
      this.listaRecorridos.map(recorrido => {
        recorrido.rutChoferFormato = this.rutService.AgregarDV(recorrido.chofer_rut)
      })
      this.onFechaLiquidacion.emit(this.formHeader.get("fecha_liquidacion").value)
      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  seleccionar(recorrido) {
    this.recorridoEnviar = recorrido;
    this.lastCodigoRecorrido = recorrido.codigo


    delete recorrido.__typename
    // Usar emitEvent: false para evitar disparar valueChanges cuando se establece programáticamente
    this.seleccionador = 0;
    this.formHeader.get('codigoRecorrido').setValue(recorrido.codigo, { emitEvent: false });
    // this.formHeader.get('chofer').setValue(this.rutService.AgregarDV(recorrido.chofer_rut));
    this.formHeader.get('choferNombre').setValue(recorrido.chofer_nombre);
    this.formHeader.get('fecha').setValue(recorrido.fecha);
    this.formHeader.get('listaEstado').setValue(recorrido.codigo_estado);
    this.onSelect.emit(recorrido)

  }

  iniciarLiquidacion(){
    this.HiddeTable = true
    this.onrecorridoIniciado.emit(this.recorridoEnviar);
  }

  limpiarfiltros(){
    this.HiddeTable = true;
    this.recorridoEnviar = null;
    this.HighlightRow = null;
    // Establecer seleccionador antes de resetear para evitar que se dispare el autocompletado
    this.seleccionador = 0;
    this.formHeader.reset();
    this.dpFecha.clearDate();
    this.onClean.emit();
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('listaEstado'), this.optionsEstado)
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader.get('fecha_liquidacion').setValue(currentDate, { emitEvent: false });
    // Resetear seleccionador después del reset para que funcione la próxima vez que el usuario escriba
    this.seleccionador = 1;
  }

  // FILTRAR CODIGO ESCRIBIENDOLO
  private formChangesSubscriptions() {

    this.formHeader.get("codigoRecorrido").valueChanges
    .pipe(
      debounceTime(750),
      distinctUntilChanged(),
    )
    .subscribe((nroRecorrido: string) => {
      // Solo procesar si hay un valor y el usuario está escribiendo (no es una selección programática)
      if (nroRecorrido && nroRecorrido.toString().trim() !== '' && this.seleccionador == 1) {
        const numero = Number(nroRecorrido);
        // Buscar con cualquier longitud de código (permite códigos de 1, 2, 3 dígitos, etc.)
        // Solo buscar si es un número válido y mayor a 0
        if (!isNaN(numero) && numero > 0) {
          this.modalSeleccionarRecorrido.searchByCodigo(numero);
        }
      }
      // Resetear seleccionador después de procesar
      this.seleccionador = 1;
    })


  }

  onRecorridoSeleccionado(recorrido) {
    this.listaRecorridos = []
    this.log('Seleccionó', recorrido)
    this.clearResults('onRecorridoSeleccionado')
    this.recorridoSeleccionado = recorrido
    // Usar emitEvent: false para evitar disparar valueChanges cuando se establece programáticamente
    this.seleccionador = 0;
    this.formHeader.get('codigoRecorrido').setValue(recorrido.codigo, { emitEvent: false });
    // this.formHeader.get('chofer').setValue(this.rutService.AgregarDV(recorrido.chofer_rut));
    this.formHeader.get('fecha').setValue(recorrido.fecha);
    this.formHeader.get('listaEstado').setValue(recorrido.codigo_estado);
    this.formHeader.get('choferNombre').setValue(recorrido.chofer_nombre);
    this.ClickedRow(0,recorrido);
    this.seleccionador = 1;
    this.buscar(1);
    // this.modalSeleccionarRecorrido.clearLast()
  }

  onNotFoundRecorrido(){
    // No limpiar el campo codigoRecorrido cuando no se encuentra un resultado
    // El usuario puede estar escribiendo y no queremos borrar lo que está escribiendo
    this.clearRecorridoDataSinBorrarCodigo()
  }

  clearRecorridoData(){
    this.recorridoSeleccionado = null;
    this.HighlightRow = null;
    // Establecer seleccionador antes de limpiar para evitar que se dispare el autocompletado
    this.seleccionador = 0;
    this.formHeader.get('fecha').setValue(null, { emitEvent: false });
    this.formHeader.get('codigoRecorrido').setValue(null, { emitEvent: false });
    this.formHeader.get('choferNombre').setValue(null, { emitEvent: false });
    this.loading= false;
    this.listaRecorridos = []
    // Resetear seleccionador después de limpiar para que funcione la próxima vez que el usuario escriba
    this.seleccionador = 1;
  }

  clearRecorridoDataSinBorrarCodigo(){
    // Limpiar datos relacionados pero mantener el código que el usuario está escribiendo
    this.recorridoSeleccionado = null;
    this.HighlightRow = null;
    this.loading = false;
    this.listaRecorridos = []
    // No borrar codigoRecorrido, fecha ni choferNombre para no interrumpir al usuario mientras escribe
  }

  clearResults(origen: string) {
    // this.log(`clearResults from`, origen)
    this.listaRecorridos = null
    this.loading = false
  }

  /********* OUTSIDE CALL *********/
  lastCodigoRecorrido: number = 0


  private notFound() {
    this.onNotFound.emit()
  }

  public clearLast() {
    this.lastCodigoRecorrido = 0
  }
  /********* OUTSIDE CALL *********/

}
